/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import WrapperBody from "components/WrapperBody";
import FooterItem from "../FooterItem";
import useStyles from "../../styles";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";

const FooterWrapper = props => {
	const { listOrderHistoryDetails } = props;

	const classes = useStyles();

	return (
		<WrapperBody
			container
			classes={{ root: classes.rootFooter }}
			id="footerHistoryOrderDetail"
		>
			<Grid classes={{ root: classes.totalBox }}>
				<FooterItem
					title="Tổng tiền"
					isBorder
					value={`${formatCash(
						listOrderHistoryDetails?.totalItemAmount
					)} Đ`}
				/>
				<FooterItem
					title="Tổng chiết khấu"
					isBorder
					value={`${formatCash(
						listOrderHistoryDetails?.discountAmount
					)} Đ`}
				/>
				<FooterItem
					title="Thành tiền"
					value={`${formatCash(
						listOrderHistoryDetails?.finalAmount
					)} Đ`}
				/>
				<Grid classes={{ root: classes.text }}>
					Giá trên đã bao gồm thuế VAT
				</Grid>
			</Grid>
		</WrapperBody>
	);
};

export default FooterWrapper;
